import { useContext } from 'react';
import { TELEGRAM_MINI_APP_URL } from '../../assets/constants/telegramLinks';
import {
  VERIFICATION_CHANNEL,
  VERIFICATION_CHANNEL_MAP,
} from '../../assets/constants/verificationChannels';
import { TranslationContext } from '../../assets/contexts/translationContext';
import './StartupGate.css';

const TelegramIcon = VERIFICATION_CHANNEL_MAP[VERIFICATION_CHANNEL.TELEGRAM].Icon;

function closeTelegramMiniApp() {
  const webApp = window.Telegram?.WebApp;

  if (typeof webApp?.close === 'function') {
    webApp.close();
    return;
  }

  window.close();
}

const PMAccessIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M20 11c0-2.288-.674-3.693-1.85-4.575C16.91 5.495 14.927 5 12 5s-4.91.495-6.15 1.425C4.674 7.307 4 8.712 4 11c0 1.42.263 2.491.722 3.299.452.795 1.134 1.405 2.102 1.848a1 1 0 0 1 .527 1.245l-.654 1.827 5.212-2.145.089-.032a1 1 0 0 1 .28-.044c2.826-.031 4.737-.541 5.931-1.468C19.346 14.648 20 13.253 20 11M8.01 10a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2zm4 0a1 1 0 1 1 0 2H12a1 1 0 1 1 0-2zm4 0a1 1 0 1 1 0 2H16a1 1 0 1 1 0-2zM22 11c0 2.666-.798 4.738-2.564 6.11-1.672 1.297-4.047 1.83-6.939 1.883l-7.116 2.932a1 1 0 0 1-1.322-1.26l1.118-3.135a6.2 6.2 0 0 1-2.195-2.243C2.305 14.096 2 12.657 2 11c0-2.711.826-4.807 2.65-6.175C6.41 3.505 8.927 3 12 3s5.59.505 7.35 1.825C21.174 6.193 22 8.29 22 11"
    />
  </svg>
);

const RefreshIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.636 5.636a9 9 0 0 1 12.392-.32l.336.32.032.034 1.588 1.745V6a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1H17a1 1 0 0 1 0-2h1.723l-1.795-1.972a7 7 0 1 0 1.563 7.598 1 1 0 0 1 1.855.748 9 9 0 1 1-14.71-9.738"
    />
  </svg>
);

const RefIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.5 13c1.882 0 3.441.26 4.653.861 1.252.621 2.087 1.584 2.511 2.85.307.916.022 1.782-.526 2.375A2.93 2.93 0 0 1 14 20H5c-.82 0-1.607-.34-2.138-.914-.548-.593-.833-1.46-.526-2.375.424-1.266 1.26-2.229 2.51-2.85C6.06 13.261 7.619 13 9.5 13m8.195.144c1.258.181 2.33.546 3.182 1.146a4.72 4.72 0 0 1 1.787 2.42c.307.917.022 1.783-.526 2.376A2.93 2.93 0 0 1 20 20h-1.495a1 1 0 0 1 0-2H20a.93.93 0 0 0 .67-.273c.12-.13.141-.249.098-.38a2.73 2.73 0 0 0-1.042-1.422c-.518-.365-1.262-.65-2.317-.802a1 1 0 0 1 .286-1.98M9.5 15c-1.73 0-2.941.245-3.765.653-.784.39-1.25.94-1.503 1.694-.043.131-.023.25.098.38.139.15.386.273.67.273h9a.93.93 0 0 0 .67-.273c.12-.13.142-.249.098-.38-.253-.753-.72-1.305-1.503-1.694C12.44 15.245 11.23 15 9.5 15M11 8c0-.974-.196-1.434-.382-1.65C10.461 6.17 10.17 6 9.5 6s-.961.169-1.118.35C8.196 6.567 8 7.027 8 8s.196 1.434.382 1.65c.157.181.448.35 1.118.35s.961-.169 1.118-.35C10.804 9.433 11 8.973 11 8m6 0c0-.974-.196-1.434-.382-1.65C16.461 6.17 16.17 6 15.5 6c-.301 0-.528.035-.698.089a1 1 0 0 1-.604-1.907C14.61 4.052 15.05 4 15.5 4c.997 0 1.956.26 2.632 1.043C18.779 5.792 19 6.832 19 8s-.221 2.208-.868 2.957C17.455 11.74 16.497 12 15.5 12c-.45 0-.89-.051-1.302-.182a1 1 0 0 1 .604-1.907c.17.054.397.089.698.089.67 0 .961-.169 1.118-.35.186-.216.382-.676.382-1.65m-4 0c0 1.168-.221 2.208-.868 2.957C11.456 11.74 10.497 12 9.5 12s-1.956-.26-2.632-1.043C6.221 10.208 6 9.168 6 8s.221-2.208.868-2.957C7.544 4.26 8.503 4 9.5 4s1.956.26 2.632 1.043C12.779 5.792 13 6.832 13 8"
    />
  </svg>
);

function StartupGate({
  title,
  text,
  action,
  Icon,
  href,
  onAction,
  disabled = false,
  variant = 'default',
}) {
  const className = ['startup-gate', `startup-gate--${variant}`].join(' ');

  return (
    <section className={className}>
      <div className="startup-gate__content">
        <div className="startup-gate__mark" aria-hidden="true">
          <Icon className="startup-gate__icon" />
        </div>
        <h1 className="startup-gate__title">{title}</h1>
        <p className="startup-gate__text">{text}</p>
      </div>

      {href ? (
        <a className="startup-gate__button" href={href}>
          {action}
        </a>
      ) : (
        <button
          type="button"
          className="startup-gate__button"
          onClick={onAction}
          disabled={disabled}
        >
          {action}
        </button>
      )}
    </section>
  );
}

export function TelegramRequiredScreen() {
  const { startup } = useContext(TranslationContext);

  return (
    <StartupGate
      variant="telegram"
      Icon={TelegramIcon}
      title={startup.telegramRequiredTitle}
      text={startup.telegramRequiredText}
      action={startup.openTelegram}
      href={TELEGRAM_MINI_APP_URL}
    />
  );
}

export function ReferralRequiredScreen() {
  const { startup } = useContext(TranslationContext);

  return (
    <StartupGate
      variant="referral"
      Icon={RefIcon}
      title={startup.referralRequiredTitle}
      text={startup.referralRequiredText}
      action={startup.openTelegram}
      href={TELEGRAM_MINI_APP_URL}
    />
  );
}

export function LoginErrorScreen({ isRetrying = false, onRetry }) {
  const { common, startup } = useContext(TranslationContext);

  return (
    <StartupGate
      variant="error"
      Icon={PMAccessIcon}
      title={startup.loginErrorTitle}
      text={startup.loginErrorText}
      action={isRetrying ? common.retrying : common.tryAgain}
      onAction={onRetry}
      disabled={isRetrying}
    />
  );
}

export function SessionExpiredScreen() {
  const { common, startup } = useContext(TranslationContext);

  return (
    <StartupGate
      variant="session-expired"
      Icon={RefreshIcon}
      title={startup.sessionExpiredTitle}
      text={startup.sessionExpiredText}
      action={common.closeApp}
      onAction={closeTelegramMiniApp}
    />
  );
}

export function PmPermissionScreen({ denied = false, isRequesting = false, onRequest }) {
  const { common, startup } = useContext(TranslationContext);

  return (
    <StartupGate
      variant={denied ? 'pm-denied' : 'pm'}
      Icon={PMAccessIcon}
      title={denied ? startup.pmDeniedTitle : startup.pmRequiredTitle}
      text={startup.pmText}
      action={isRequesting ? common.requesting : startup.allowMessages}
      onAction={onRequest}
      disabled={isRequesting}
    />
  );
}
